// import Error from 'components/alerts/Error';
import { NumberInput } from 'components/common/form/modules/input/Number';
import { Text } from 'components/common/form/modules/input/Text';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { findCampaignBySubdomain, findUserByUsername, getInventoryAsStringForCheckout, incPageViews, preBid, prePurchase } from 'components/graphql/queries'
import Layout from 'components/misc/Layout';
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import { stripeConfig } from 'config/stripe';
import { getCookie } from 'lib/utils/cookie';
import { stripUriParamsString } from 'lib/utils/helpers';
import React, { useCallback, useEffect, useState } from 'react'
import { withCookies } from 'react-cookie';
import Moment from 'react-moment'
import { ClipLoader } from 'react-spinners';
import { injectStripe } from 'react-stripe-elements';

import { geocodeByPlaceId } from 'react-google-places-autocomplete';
import { LogoFacebook, LogoInstagram, LogoYoutube } from 'react-ionicons'

import MapComponent from '../../../components/map'

import { Info } from 'components/common/form/modules/Info';
import { Card, CardBody, CardImg, Col, Row } from 'reactstrap';
import Description from '../CampaignsDashboard/Description';
import ChooseInventory from './ChooseInventory';

import { loadStripe } from '@stripe/stripe-js';

import { ResponsiveScatterPlot } from '@nivo/scatterplot'


const CheckoutPage: React.FC<{ [label: string]: any }> = (props: any) => {

    const url = window.location.href.toLowerCase();
    const urlItems = url.split('/')

    const source = urlItems[2].split('.')[0]
    let runningLocally = false;
    if (source === 'localhost:3000' || source === 'test') {
        runningLocally = true;
    }
    const [subdomain] = useState(stripUriParamsString(runningLocally ? props.match.params.subdomain : props.subdomain))
    const [username] = useState(stripUriParamsString(runningLocally ? props.match.params.username : props.username))

    const [sellerId, setSellerId] = useState('')
    const [loading, setLoading] = useState(true)

    const [viewsIncrementedConfirmation, setViewsIncrementedConfirmation] = useState(false)

    const [campaign, setCampaign] = useState<any>({
        id: '',
        name: '',
        isActive: true,
        description: '',
        collectAddress: false,
        surveyQuestion: '',
        createdBy: '',
        startTime: {
            year: 0,
            month: 0,
            day: 0,
            hour: 0,
            minute: 0,
            PM: false,
        },
        timezoneOffset: -7,
        media: {
            cover: '',
            logo: ''
        },
        fee: {
            perItemFee: 100,
            perOrderFee: 0.03,
            maxItemsPerOrder: 10
        },
        floorplan: {
            height: 1,
            width: 1,
            labels: [],
            inventoryMap: []
        },
        hideDisplayTime: false,
        location: null,
        secretLocation: null,
        earlyPayout: false,
        standardStripeId: ''
    })

    const [data, setData] = useState([])
    const [currNode, setCurrNode] = useState({
        x: -1, y: -1, inventoryItemId: '', bought: false
    })

    const [marker, setMarker] = useState<any>(null)

    useEffect(() => {
        if (campaign.location !== undefined && campaign.location !== null && campaign.secretLocation !== true) {
            const loc = JSON.parse(campaign.location)
            geocodeByPlaceId(loc.value.place_id)
                .then(results => {
                    const mark = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng()
                    }
                    setMarker(mark)
                })
                .catch(er => console.error(er));
        }
    }, [campaign])

    // const [error, setError] = useState(false)
    // const [errorMessage, setErrorMessage] = useState('')

    const [address, setAddress] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [confirmEmail] = useState('')

    const [inventory, setInventory] = useState([])
    const [order, setOrder] = useState({})
    const [quantityMap, setQuantityMap] = useState({})
    const [priceMap, setPriceMap] = useState({})
    const [ticketCount, setTicketCount] = useState(0)

    const [charging, setCharging] = useState(false)

    const [bidId, setBidId] = useState('')
    const [bid, setBid] = useState(0)
    const [currBid, setCurrBid] = useState(0)
    const [numBids, setNumBids] = useState(0)

    const [imageHeight, setImageHeight] = useState(0)

    const onImgLoad = useCallback(({ target: img }) => {
        setImageHeight(img.offsetHeight)
    }, [setImageHeight])

    const subtotal = useCallback(() => {
        let sub = 0;
        Object.keys(order).map((key: any) => {
            if (key.toString().trim() === bidId.toString().trim()) {
                sub += (bid * 100)
            } else {
                sub += (order[key] * priceMap[key])
            }
        })
        return sub
    }, [order, priceMap, bidId, bid])

    const serviceFee = useCallback(() => {

        const sub = subtotal()
        if (sub === 0) {
            return 0
        }

        let subtotalWithServiceFee = 0;
        Object.keys(order).map((key: any) => {
            if (key.toString().trim() === bidId.toString().trim()) {
                subtotalWithServiceFee += (((bid * 100) * (1 + campaign.fee.perOrderFee)) + (priceMap[key] === 0 ? 0 : (order[key] * campaign.fee.perItemFee)))
            } else {
                subtotalWithServiceFee += (((order[key] * priceMap[key]) * (1 + campaign.fee.perOrderFee)) + (priceMap[key] === 0 ? 0 : (order[key] * campaign.fee.perItemFee)))
            }

        })
        return subtotalWithServiceFee - sub;

    }, [order, subtotal, campaign, bid])

    const processingFee = useCallback(() => {
        if (subtotal() === 0) {
            return 0;
        }
        const subTotalWithSf = subtotal() + serviceFee();
        const totalPrice = (subTotalWithSf + 30) / (1 - 0.029);
        return parseInt(totalPrice.toFixed(0), 0) - subTotalWithSf;
    }, [order, subtotal, serviceFee])

    const emailIsValid = (e) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
    }

    const handleOrderChange = useCallback((inventoryItemId, add) => {

        console.log(order)
        console.log(quantityMap)

        if (bidId.toString().trim() !== ('').toString().trim()) {
            return;
        }

        let totalOrderCount = 0;
        Object.keys(order).map((key: any) => {
            totalOrderCount += order[key]
        })

        if (add) {

            if (totalOrderCount >= campaign.fee.maxItemsPerOrder) {
                return;
            }

            if (order[inventoryItemId] >= quantityMap[inventoryItemId]) {
                return;
            } else {
                const updatedOrder = JSON.parse(JSON.stringify(order))
                updatedOrder[inventoryItemId]++;
                setOrder(updatedOrder)
                setTicketCount(ticketCount + 1)
            }
        } else {
            if (order[inventoryItemId] <= 0) {
                return;
            } else {
                const updatedOrder = JSON.parse(JSON.stringify(order))
                updatedOrder[inventoryItemId]--;
                setOrder(updatedOrder)
                setTicketCount(ticketCount - 1)
            }
        }
    }, [order, ticketCount, quantityMap, setOrder, setTicketCount, currNode, campaign.fee.maxItemsPerOrder])

    const onClickNode = useCallback((n, e) => {

        const label = campaign.floorplan.labels.find((item: any) => {
            return item.x === n.data.x && item.y === n.data.y
        })
        if (label) {
            return
        }
        const mapItem: any = campaign.floorplan.inventoryMap.find((item: any) => {
            return item.x === n.data.x && item.y === n.data.y && !item.bought
        })
        if (!mapItem) {
            return
        }

        let count = ticketCount;
        let updatedOrder = JSON.parse(JSON.stringify(order))
        if (currNode.inventoryItemId.toString().trim() !== ('').toString().trim()) {
            updatedOrder[currNode.inventoryItemId]--;
            count--;
            setBidId('')
            setCurrBid(0)
            setNumBids(0)
        }
        // add new count
        if (currNode.x === n.data.x && currNode.y === n.data.y) {
            setCurrNode({
                x: -1, y: -1, inventoryItemId: '', bought: false
            })
        } else {

            let totalOrderCount = 0;
            Object.keys(order).map((key: any) => {
                totalOrderCount += order[key]
            })

            if (totalOrderCount >= campaign.fee.maxItemsPerOrder) {
                return;
            }

            if (mapItem.bid) {
                // set Bid ID
                setBidId(mapItem.inventoryItemId)
                setCurrBid(mapItem.bid.currentBid)
                setNumBids(mapItem.bid.numBids)
                updatedOrder = {
                    [mapItem.inventoryItemId]: 1
                }
            } else {
                if (updatedOrder[mapItem.inventoryItemId]) {
                    updatedOrder[mapItem.inventoryItemId]++;
                } else {
                    updatedOrder[mapItem.inventoryItemId] = 1;
                }
            }
            count++;
            setCurrNode(mapItem)
        }

        setOrder(updatedOrder)
        setTicketCount(count)

    }, [campaign, currNode, setCurrNode, handleOrderChange, order, ticketCount, setTicketCount, setOrder, setBidId, setCurrBid, setNumBids, campaign.fee.maxItemsPerOrder])

    const handlePurchase = useCallback(() => {

        setCharging(true)

        if (name.toString().trim() === '') {
            setCharging(false)
            alert('Please fill out name')
            return
        }
        if (email.toString() === '') {
            setCharging(false)
            alert('Please fill out all fields')
            return
        }
        if (!emailIsValid(email.toString())) {
            setCharging(false)
            alert('Email is invalid')
            return
        }
        // if (email.toString() !== confirmEmail.toString()) {
        //     setError(true)
        //     setCharging(false)
        //     setErrorMessage('Emails do not match')
        //     return
        // }

        if (campaign.collectAddress && address.toString().trim() === '') {
            setCharging(false)
            alert(campaign.surveyQuestion)
            return;
        }

        if (Number.isNaN(Number(bid))) {
            setCharging(false)
            alert('Bid amount is invalid')
            return
        }

        console.log(phoneNumber)
        console.log(Number(phoneNumber))

        if (Number.isNaN(Number(phoneNumber)) || phoneNumber.length !== 10) {
            setCharging(false)
            alert('Phone number is invalid')
            return
        }

        if (bidId.toString().trim() !== ('').toString().trim()) {
            if (numBids > 0) {
                if (Number(bid) * 100 <= currBid) {
                    setCharging(false)
                    alert('Entered bid should be greater than the current bid')
                    return
                }
            } else {
                if (Number(bid) * 100 < currBid) {
                    setCharging(false)
                    alert('Entered bid should match the current bid')
                    return
                }
            }
        }

        const orderComponents: any[] = []
        Object.keys(order).map((key) => {
            if (order[key] > 0) {
                orderComponents.push({
                    inventoryItemId: key,
                    count: order[key],
                    validated: 0
                })
            }
        })

        if (bidId.toString().trim() !== ('').toString().trim()) {
            fetchAPI
                .post(API_ENDPOINTS.BASE_URL, {
                    query: preBid,
                    variables: {
                        name,
                        email,
                        phoneNumber,
                        address: campaign.collectAddress ? address : null,
                        campaignId: campaign.id,
                        sellerId,
                        bid,
                        bidId,
                        floorplanLocationX: currNode.inventoryItemId.toString().trim() !== ('').toString().trim() ? currNode.x.toString() : null,
                        floorplanLocationY: currNode.inventoryItemId.toString().trim() !== ('').toString().trim() ? currNode.y.toString() : null
                    }
                })
                .then(async (res) => {
                    if (res.data.data.order.preBid !== 'Purchase-Error') {

                        // For free ticket directly reach out to the mutation
                        if (res.data.data.order.preBid.includes('Free-Ticket-')) {
                            window.location.href = res.data.data.order.preBid.split('Free-Ticket-')[1] + '?session_id=FREE_TICKET'
                        }

                        const stripePromise = campaign.earlyPayout ? loadStripe(stripeConfig.apiKey, {
                            stripeAccount: campaign.standardStripeId
                        }) : loadStripe(stripeConfig.apiKey)

                        const stripe: any = await stripePromise;
                        const result = await stripe.redirectToCheckout({
                            sessionId: res.data.data.order.preBid,
                        });

                        if (result.error) {
                            alert('Something went wrong, refresh page and try again')
                            setCharging(false)
                        }

                    } else {
                        alert('Something went wrong, refresh page and try again')
                        setCharging(false)
                    }
                })
                .catch(err => {
                    console.log(err)
                    alert('Something went wrong, refresh page and try again')
                    setCharging(false)
                    return
                })
        } else {
            fetchAPI
                .post(API_ENDPOINTS.BASE_URL, {
                    query: prePurchase,
                    variables: {
                        name,
                        email,
                        phoneNumber,
                        address: campaign.collectAddress ? address : null,
                        orderComponents,
                        campaignId: campaign.id,
                        sellerId,
                        floorplanLocationX: currNode.inventoryItemId.toString().trim() !== ('').toString().trim() ? currNode.x.toString() : null,
                        floorplanLocationY: currNode.inventoryItemId.toString().trim() !== ('').toString().trim() ? currNode.y.toString() : null
                    }
                })
                .then(async (res) => {
                    if (res.data.data.order.prePurchase !== 'Purchase-Error') {

                        // For free ticket directly reach out to the mutation
                        if (res.data.data.order.prePurchase.includes('Free-Ticket-')) {
                            window.location.href = res.data.data.order.prePurchase.split('Free-Ticket-')[1] + '?session_id=FREE_TICKET'
                        }

                        const stripePromise = campaign.earlyPayout ? loadStripe(stripeConfig.apiKey, {
                            stripeAccount: campaign.standardStripeId
                        }) : loadStripe(stripeConfig.apiKey)

                        const stripe: any = await stripePromise;
                        const result = await stripe.redirectToCheckout({
                            sessionId: res.data.data.order.prePurchase,
                        });

                        if (result.error) {
                            alert('Something went wrong, refresh page and try again')
                            setCharging(false)
                        }

                    } else {
                        setCharging(false)
                        alert('Something went wrong, refresh page and try again')
                    }
                })
                .catch(err => {
                    setCharging(false)
                    alert('Something went wrong, refresh page and try again')
                    return
                })
        }

    }, [order, name, openModal, closeModal, phoneNumber,
        email, campaign, confirmEmail, setCharging, inventory, address,
        subtotal, sellerId, currNode, bidId, bid, currBid, numBids])

    useEffect(() => {
        if (!subdomain || subdomain === '') {
            return
        }
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: findCampaignBySubdomain,
                variables: {
                    subdomain
                }
            })
            .then(res => {
                setCampaign(res.data.data.campaign.findBySubdomain)
                if (username) {
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: findUserByUsername,
                            variables: {
                                username
                            }
                        })
                        .then(res2 => {
                            setSellerId(res2.data.data.user.findByUsername.id)
                            fetchAPI
                                .post(API_ENDPOINTS.BASE_URL, {
                                    query: getInventoryAsStringForCheckout,
                                    variables: {
                                        campaignId: res.data.data.campaign.findBySubdomain.id,
                                        sellerId: res2.data.data.user.findByUsername.id
                                    }
                                })
                                .then(res3 => {
                                    setLoading(false)
                                    const int = JSON.parse(res3.data.data.inventoryItem.getInventoryAsStringForCheckout)
                                    setInventory(int)
                                    const initOrder = {}
                                    const quantities = {}
                                    const prices = {}
                                    int.map((item) => {
                                        initOrder[item.id] = 0;
                                        quantities[item.id] = item.available
                                        prices[item.id] = item.price
                                    })
                                    setOrder(initOrder)
                                    setQuantityMap(quantities)
                                    setPriceMap(prices)
                                })
                                .catch(err => {
                                    console.log(err)
                                })
                        })
                        .catch(err => {
                            console.log(err)
                        })
                } else {
                    setSellerId(res.data.data.campaign.findBySubdomain.createdBy)
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: getInventoryAsStringForCheckout,
                            variables: {
                                campaignId: res.data.data.campaign.findBySubdomain.id,
                                sellerId: res.data.data.campaign.findBySubdomain.createdBy
                            }
                        })
                        .then(res2 => {
                            setLoading(false)
                            const int = JSON.parse(res2.data.data.inventoryItem.getInventoryAsStringForCheckout)
                            setInventory(int)
                            const initOrder = {}
                            const quantities = {}
                            const prices = {}
                            int.map((item) => {
                                initOrder[item.id] = 0;
                                quantities[item.id] = item.available
                                prices[item.id] = item.price
                            })
                            setOrder(initOrder)
                            setQuantityMap(quantities)
                            setPriceMap(prices)
                        })
                        .catch(err => {
                            console.log(err)
                        })
                }
            })
            .catch(err => {
                console.log(err)
            })

    }, [setLoading, subdomain, setCampaign, username, setInventory, setOrder, setQuantityMap, setPriceMap, setSellerId])

    useEffect(() => {
        if (campaign.floorplan) {

            const initData: any = [];

            const sold: any = []
            inventory.map((item: any) => {
                campaign.floorplan.inventoryMap.map((i: any) => {
                    if (i.bought) {
                        sold.push({
                            x: i.x, y: i.y
                        })
                    }
                })

            })
            initData.push({
                id: 'Unavailable',
                data: sold
            })

            const selected: any[] = []

            inventory.map((item: any) => {

                // Making sure the inventory is active
                if (item.sellAfter) {
                    const precursor: any = inventory.find((i: any) => {
                        return i.id.toString().trim() === item.sellAfter.toString().trim()
                    })
                    if (precursor && precursor.quantity !== precursor.bought) {
                        return null
                    }
                }

                if (item.sell) {
                    const d: any = []
                    campaign.floorplan.inventoryMap.map((i: any) => {
                        if (item.id.toString().trim() === i.inventoryItemId.toString().trim()
                            && !i.bought
                        ) {
                            if (i.bid) {
                                const ATZ = -1 * new Date().getTimezoneOffset() / 60;
                                const currTime = new Date();
                                const start = new Date(
                                    item.startTime.year,
                                    item.startTime.month - 1,
                                    item.startTime.day,
                                    (item.startTime.PM ? item.startTime.hour + 12 : item.startTime.hour),
                                    item.startTime.minute
                                )
                                const end = new Date(
                                    item.endTime.year,
                                    item.endTime.month - 1,
                                    item.endTime.day,
                                    (item.endTime.PM ? item.endTime.hour + 12 : item.endTime.hour),
                                    item.endTime.minute
                                )
                                end.setHours(end.getHours() + (ATZ - campaign.timezoneOffset));
                                start.setHours(start.getHours() + (ATZ - campaign.timezoneOffset));
                                if (end < currTime || start > currTime) {
                                    return;
                                }
                            }
                            d.push({
                                x: i.x, y: i.y
                            })
                        }
                    })
                    initData.push({
                        id: item.name,
                        data: d
                    })
                }
            })

            if (selected.length > 0) {
                initData.push({
                    id: selected[0].name,
                    data: [{
                        x: selected[0].x, y: selected[0].y
                    }]
                })
            }

            campaign.floorplan.labels.map((item: any) => {
                initData.push({
                    id: item.label,
                    data: [{ x: item.x, y: item.y }]
                })
            })

            setData(initData)
        }
    }, [setData, campaign, inventory, currNode])

    const getDescription = useCallback((node: any) => {

        let content = <div />

        const item: any = inventory.find((i: any) => {
            return i.name.toString().trim() === node.data.serieId.toString().trim()
        })

        const inventoryMapItem: any = campaign.floorplan ? campaign.floorplan.inventoryMap.find((i: any) => {
            return i.x === node.data.x && i.y === node.data.y
        }) : null

        let bidExists = false;
        let currBidLabel = 0;
        if (inventoryMapItem) {
            if (inventoryMapItem.bid && !inventoryMapItem.bought) {
                bidExists = true
                currBidLabel = inventoryMapItem.bid.currentBid
            }
        }
        if (item) {
            content = <div>
                {
                    item.name
                }
                <br />
                {
                    bidExists ?
                        'Bid $' + (currBidLabel / 100).toFixed(2)
                        : '$' + (item.price / 100).toFixed(2)
                }
                <br />
                {item.description}
            </div>
        } else {
            content = <div>
                Unavailable
            </div>
        }
        return <div
            className='blur-safari'
            style={{
                padding: '10px',
                color: '#242d51',
                borderRadius: '15px',
                backdropFilter: 'blur(20px)',
                border: '0.4px solid #f1f1f1',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02), 0 1px 3px rgba(0, 0, 0, 0.02)'
            }}
        >
            {content}
        </div>
    }, [inventory, campaign])

    const CustomNode = useCallback(({
        node,
        x,
        y,
        size,
        color,
        blendMode,
        onMouseEnter,
        onMouseMove,
        onMouseLeave,
        onClick,
    }) => {

        if (node.data.serieId === 'Available') {
            return <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                <circle
                    stroke={"#242d51"}
                    stroke-width="0.5"
                    fill-opacity={0.4}
                    stroke-opacity={0.75}
                    r={size * 0.5}
                    fill={'#f1f1f1'}
                    style={{ mixBlendMode: blendMode, zIndex: 15000000, opacity: 1 }}
                    onMouseEnter={onMouseEnter}
                    onMouseMove={onMouseMove}
                    onMouseLeave={onMouseLeave}
                    onClick={onClick}
                />
            </g>
        }

        const label: any = campaign.floorplan ? campaign.floorplan.labels.find((i: any) => {
            return i.label.toString().trim() === node.data.serieId.toString().trim()
        }) : null

        let selected = false;
        if (currNode.inventoryItemId.toString().trim() !== ('').toString().trim()) {
            if (currNode.x === node.data.x && currNode.y === node.data.y) {
                selected = true;
            }
        }

        const inventoryItem: any = inventory.find((item: any) => {
            return item.name.toString().trim() === node.data.serieId.toString().trim()
        })

        if (!label) {
            return (
                <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                    <circle
                        stroke={inventoryItem && !selected ? "#242d51" : '#f1f1f1'}
                        stroke-width="0.5"
                        fill-opacity={selected ? 1 : 0.4}
                        stroke-opacity={0.75}
                        r={size * 0.5}
                        fill={selected ? '#d63191' : (inventoryItem ? '#f1f1f1' : '#242d51')}
                        style={{ mixBlendMode: blendMode, zIndex: 15000000, opacity: 1 }}
                        onMouseEnter={onMouseEnter}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseLeave}
                        onClick={onClick}
                    />
                </g>
            )
        }
        return (
            <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                <text
                    x={size * -1}
                    y={size * 0.5}
                    font-size='8px'
                    font-style='bold'
                    color='#1931b9'
                    font-color='#1931b9'
                    style={{ zIndex: 150, opacity: 1 }}
                >
                    {label.label.toUpperCase()}
                </text>
            </g>
        )
    }, [campaign, inventory, currNode, data])

    // increase page views for selling pages
    useEffect(() => {

        // no need to run this function if campaign hasn't changed
        if (!subdomain || subdomain === '') {
            return
        }

        if (!getCookie('user') && !getCookie('token')) {
            // to ensure not logged in
            if (username) {
                // Affiliate link
                if (!getCookie(subdomain + username) && !viewsIncrementedConfirmation) {
                    // increase page view
                    // set cookie
                    setViewsIncrementedConfirmation(true)
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: incPageViews,
                            variables: {
                                subdomain,
                                username
                            }
                        })
                        .then((res) => {
                            if (res.data.data.campaign.incrementLinkPageViews) {
                                const date = new Date(); date.setDate(date.getDate() + 7);
                                props.cookies.set(subdomain + username, subdomain + username, { path: "/", expires: date });
                            }
                        })
                }
            } else {
                // Owner's link
                if (!getCookie(subdomain) && !viewsIncrementedConfirmation) {
                    // increase page view
                    // set cookie
                    setViewsIncrementedConfirmation(true)
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: incPageViews,
                            variables: {
                                subdomain
                            }
                        })
                        .then((res) => {
                            if (res.data.data.campaign.incrementLinkPageViews) {
                                const date = new Date(); date.setDate(date.getDate() + 7);
                                props.cookies.set(subdomain, subdomain, { path: "/", expires: date });
                            }
                        })
                }
            }
        }

    }, [campaign, username, subdomain, props.cookies, setViewsIncrementedConfirmation, viewsIncrementedConfirmation])

    let unmappedTicketInventoryCount = 0;
    inventory.map((item: any, index: number) => {
        const mappedItem = campaign.floorplan ? campaign.floorplan.inventoryMap.find((i: any) => {
            return i.inventoryItemId.toString().trim() === item.id.toString().trim()
        }) : undefined
        if (!mappedItem) {
            unmappedTicketInventoryCount++;
        }
    })
    // const mappedTicketInventoryCount = inventory.length - unmappedTicketInventoryCount;

    if (loading) {
        return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
            <div className="p-4 w-100 text-center">
                <ClipLoader color={"#000"} loading={true} />
            </div>
        </div>
    }

    const leftCol = <>
        <Card>
            <CardImg top={true}
                src={campaign.media.cover ? campaign.media.cover : 'https://platform.isotopeticketing.com/landing.png'}
                alt="Campaign Image"
                style={{
                    borderTopLeftRadius: '15px',
                    borderTopRightRadius: '15px',
                    objectFit: 'contain'
                }}
            />
            <CardBody>
                <h3 className='cut-text' style={{ width: '100%' }}>
                    {campaign.name}
                </h3>
                {
                    campaign.hideDisplayTime ? null :
                        <p className='gray-text'>
                            <Moment format="D MMM 'YY, " style={{ paddingRight: '5px', paddingLeft: '4px' }}>
                                {Number(new Date(
                                    campaign.startTime.year,
                                    campaign.startTime.month - 1,
                                    campaign.startTime.day,
                                    (campaign.startTime.PM ? campaign.startTime.hour + 12 : campaign.startTime.hour),
                                    campaign.startTime.minute
                                ))}
                            </Moment>
                            <Moment format="hh:mm A">
                                {Number(new Date(
                                    campaign.startTime.year,
                                    campaign.startTime.month - 1,
                                    campaign.startTime.day,
                                    (campaign.startTime.PM ? campaign.startTime.hour + 12 : campaign.startTime.hour),
                                    campaign.startTime.minute
                                ))}
                            </Moment>
                        </p>
                }
                <Description>
                    {campaign.description}
                </Description>
            </CardBody>
            {
                marker ?
                    <div>
                        <MapComponent
                            marker={marker}
                        />
                    </div>
                    : null
            }
        </Card>
    </>

    const rightCol = <>
        {
            (campaign.isActive && unmappedTicketInventoryCount > 0) || inventory.length === 0 ?
                <Card style={{ padding: '25px', marginBottom: '25px' }}>
                    {
                        inventory.length > 0 ?
                            <h6>
                                CHOOSE TICKETS
                            </h6> : null
                    }
                    {
                        inventory.map((item: any, index: number) => {
                            const mappedItem = campaign.floorplan ? campaign.floorplan.inventoryMap.find((i: any) => {
                                return i.inventoryItemId.toString().trim() === item.id.toString().trim()
                            }) : undefined
                            if (mappedItem) {
                                return null;
                            }
                            if (item.quantity === item.bought) {
                                return <ChooseInventory
                                    key={index} selected={order[item.id]}
                                    name={item.name}
                                    price={item.price}
                                    description={item.description || ''}
                                    add={() => handleOrderChange(item.id, true)}
                                    subtract={() => handleOrderChange(item.id, false)}
                                    soldOut={true}
                                />
                            }
                            if (item.sellAfter) {
                                const precursor: any = inventory.find((i: any) => {
                                    return i.id.toString().trim() === item.sellAfter.toString().trim()
                                })
                                if (precursor && precursor.quantity !== precursor.bought) {
                                    return <ChooseInventory
                                        key={index} selected={order[item.id]}
                                        name={item.name}
                                        price={item.price}
                                        description={item.description || ''}
                                        add={() => handleOrderChange(item.id, true)}
                                        subtract={() => handleOrderChange(item.id, false)}
                                        sellAfter={true}
                                        precursor={precursor.name}
                                    />
                                }
                            }
                            if (item.autoSale) {
                                // Checking if there if inventory can sell
                                const ATZ = -1 * new Date().getTimezoneOffset() / 60;
                                const currTime = new Date();
                                const start = new Date(
                                    item.startTime.year,
                                    item.startTime.month - 1,
                                    item.startTime.day,
                                    (item.startTime.PM ? item.startTime.hour + 12 : item.startTime.hour),
                                    item.startTime.minute
                                )
                                const end = new Date(
                                    item.endTime.year,
                                    item.endTime.month - 1,
                                    item.endTime.day,
                                    (item.endTime.PM ? item.endTime.hour + 12 : item.endTime.hour),
                                    item.endTime.minute
                                )
                                end.setHours(end.getHours() + (ATZ - campaign.timezoneOffset));
                                start.setHours(start.getHours() + (ATZ - campaign.timezoneOffset));

                                if (end >= currTime && start <= currTime && item.sell) {
                                    return <ChooseInventory
                                        key={index} selected={order[item.id]}
                                        name={item.name}
                                        price={item.price}
                                        description={item.description || ''}
                                        add={() => handleOrderChange(item.id, true)}
                                        subtract={() => handleOrderChange(item.id, false)}
                                    />
                                } else {
                                    return null
                                }
                            } else if (item.sell) {
                                return <ChooseInventory
                                    key={index} selected={order[item.id]}
                                    name={item.name}
                                    price={item.price}
                                    description={item.description || ''}
                                    add={() => handleOrderChange(item.id, true)}
                                    subtract={() => handleOrderChange(item.id, false)}
                                />
                            } else {
                                return null;
                            }

                        })
                    }
                    {
                        inventory.length > 0 ?
                            null
                            : <h6 className='gray-text' style={{ width: '100%', textAlign: 'center' }}>
                                No tickets on sale.
                            </h6>
                    }
                </Card> :
                null
        }
        {
            campaign.isActive ?
                <div style={{ paddingBottom: '25px' }}>
                    {
                        campaign.floorplan && campaign.floorplan.inventoryMap.length > 0 ?
                            <Card style={{ padding: '20px', paddingBottom: campaign.media.logo ? imageHeight + 25 : campaign.floorplan.height * 26, marginBottom: '25px' }}>
                                <h6 style={{ textAlign: 'left', width: '100%', paddingBottom: '10px' }}>
                                    CHOOSE SEATING
                                </h6>
                                <div style={{ position: 'relative', marginTop: '10px' }}>
                                    <div style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>
                                        {
                                            campaign.media.logo ?
                                                <img src={campaign.media.logo ? campaign.media.logo : undefined}
                                                    onLoad={e => onImgLoad(e)}
                                                    style={{
                                                        width: '100%', opacity: 0.75, zIndex: 30, borderRadius: '10px',
                                                        maxWidth: '100%'
                                                    }} />
                                                : null
                                        }
                                    </div>
                                    <div style={{
                                        position: 'absolute',
                                        height: campaign.media.logo ? (
                                            screen.width >= 768 ? imageHeight - 25 : imageHeight - 12
                                        ) : campaign.floorplan.height * 25,
                                        width: '100%', opacity: 1, zIndex: 35,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        zoom: 100 / 92,
                                    }}>
                                        <div style={{
                                            height: campaign.media.logo ? (
                                                screen.width > 768 ? imageHeight - 25 : imageHeight - 12
                                            ) : campaign.floorplan.height * 25,
                                            width: '100%',
                                        }}>
                                            <ResponsiveScatterPlot
                                                data={data}
                                                margin={{
                                                    top: screen.width >= 768 ? 20 : 15,
                                                    bottom: screen.width >= 768 ? 20 : 15,
                                                    left: screen.width >= 768 ? 20 : 15,
                                                    right: screen.width >= 768 ? 20 : 15
                                                }}
                                                xScale={{ type: 'linear', min: 0, max: campaign.floorplan ? campaign.floorplan.width - 1 : 10 }}
                                                yScale={{ type: 'linear', min: 0, max: campaign.floorplan ? campaign.floorplan.height - 1 : 10 }}
                                                enableGridX={false}
                                                enableGridY={false}
                                                // style={{ border: '1px solid blue' }}
                                                // blendMode="multiply"
                                                axisTop={null}
                                                axisRight={null}
                                                axisLeft={null}
                                                axisBottom={null}
                                                onClick={(n, e) => onClickNode(n, e)}
                                                colors={{ scheme: 'blues' }}
                                                renderNode={CustomNode}
                                                tooltip={({ node }: any) => node.data.serieId === 'Available' ? null : getDescription(node)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Card>
                            : null
                    }
                    <Card style={{ padding: '20px', marginBottom: '25px' }}>
                        <h6 style={{ paddingBottom: '20px' }}>
                            YOUR INFORMATION
                        </h6>
                        {
                            bidId.toString().trim() !== ('').toString().trim() ?
                                <>
                                    <NumberInput
                                        label='Enter Bid'
                                        value={bid}
                                        onChange={e => setBid(e.target.value)}
                                        required={true} />
                                    <Info>
                                        {'Current Bid: $' + (currBid / 100).toFixed(2)}
                                        <br />
                                        {'Number of Bids: ' + numBids}
                                        <br />
                                        An authorized hold for the entered amount will be placed on your card.
                                        <br />
                                        You will not be charged unless you win the bid.
                                    </Info>
                                </>
                                : null
                        }
                        <div>
                            <Text
                                label='Name'
                                value={name}
                                onChange={e => setName(e.target.value)}
                                required={true}
                            />
                            <Text
                                label='E-mail'
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required={true}
                            />
                            <Text
                                label='Phone Number'
                                value={phoneNumber}
                                placeholder='10 digit number'
                                onChange={e => setPhoneNumber(e.target.value)}
                                required={true}
                            />
                            {/* <Text
                                label='Confirm Email'
                                value={confirmEmail}
                                onChange={e => setConfirmEmail(e.target.value)}
                                required={true}
                            /> */}
                        </div>
                        {
                            campaign.collectAddress ?
                                <Text
                                    // Default delivery address
                                    label={campaign.surveyQuestion ? campaign.surveyQuestion : 'Delivery Address'}
                                    value={address}
                                    onChange={e => setAddress(e.target.value)}
                                    required={campaign.collectAddress ? true : false}
                                /> : null
                        }
                        {/* {
                            error ?
                                <Error content={errorMessage} />
                                : null
                        } */}
                    </Card>
                    <Card style={{ padding: '20px' }}>
                        <p style={{ fontSize: "12px", color: "#4A4A4A", textAlign: "justify" }}>
                            <br />
                            All sales are final. In the case of a cancellation, a refund of the subtotal price will be issued to your card.
                            All service fees and payment processing fees are non-refundable.
                            By placing an order, you agree to this purchase policy, our&nbsp;
                            <span>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} href='../../../../termsandconditions.pdf' target="_blank">
                                    Terms of Use
                                </a>
                            </span>
                            &nbsp;and&nbsp;
                            <span>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} href='../../../../privacy-policy.pdf' target="_blank">
                                    Privacy Policy
                                </a>
                            </span>
                            {
                                campaign.id.toString().trim() === ('5fa5b558e260b162fc7aae24').toString().trim() ?
                                    <span>
                                        &nbsp;and&nbsp;
                                        <span>
                                            <a style={{ cursor: 'pointer', textDecoration: 'underline' }} href='../../../../sudamericana-covid.pdf' target="_blank">
                                                COVID-19 Disclaimer
                                            </a>
                                        </span>
                                    </span> : null
                            }
                            .&nbsp;This transaction will post as “ISOTOPE TICKETING” on your bank statement.
                            A confirmation will be delivered to your provided email address.
                            <br /><br />
                        </p>
                        {
                            ticketCount > 0 ?
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div style={{ width: screen.width >= 768 ? '60%' : '100%' }}>
                                        <div style={{ width: '100%', display: 'flex' }}>
                                            <span style={{ textAlign: 'left', width: '50%' }}>Subtotal</span>
                                            <span style={{ textAlign: 'right', width: '50%' }}>
                                                <b>
                                                    ${((subtotal()) / 100).toFixed(2)}
                                                </b>
                                            </span>
                                        </div>
                                        <div style={{ width: '100%', display: 'flex' }}>
                                            <span style={{ textAlign: 'left', width: '50%' }}>Service fees</span>
                                            <span style={{ textAlign: 'right', width: '50%' }}>
                                                <b>
                                                    ${((serviceFee()) / 100).toFixed(2)}
                                                </b>
                                            </span>
                                        </div>
                                        <div style={{ width: '100%', display: 'flex' }}>
                                            <span style={{ textAlign: 'left', width: '50%' }}>Card processing fees</span>
                                            <span style={{ textAlign: 'right', width: '50%' }}>
                                                <b>
                                                    ${((processingFee()) / 100).toFixed(2)}
                                                </b>
                                            </span>
                                        </div>
                                        <div style={{ width: '100%', display: 'flex' }}>
                                            <span style={{ textAlign: 'left', width: '50%' }}>Total price</span>
                                            <span style={{ textAlign: 'right', width: '50%' }}>
                                                <b>
                                                    ${((subtotal() + serviceFee() + processingFee()) / 100).toFixed(2)}
                                                </b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                : null
                        }

                        <button
                            className='new-button-blue-gradient'
                            disabled={ticketCount === 0 || charging}
                            onClick={() => handlePurchase()}
                            style={{ marginTop: '10px' }}
                        >
                            {
                                ticketCount === 0 ?
                                    'Choose Tickets'
                                    :
                                    bidId.toString().trim() !== ('').toString().trim() ?
                                        (charging ? 'PLACING BID...' : 'PLACE BID') :
                                        (charging ? 'PURCHASING...' : 'PURCHASE')
                            }
                        </button>

                    </Card>
                </div> :
                <div>
                    <Card style={{ padding: '40px', marginBottom: '25px', textAlign: 'center' }}>
                        <h5>
                            Sales Ended
                        </h5>
                    </Card>
                </div>
        }
    </>

    return <div className='container' style={{ paddingTop: '10px' }}>
        <Layout
            leftCol={leftCol}
            rightCol={rightCol}
        />
        <div style={{ height: 'auto', backgroundColor: '#f8f8f8', paddingTop: campaign.isActive ? '0px' : '175px' }}>
            <div className='container'>
                <Row style={{ textAlign: 'center' }}>
                    <Col style={{ paddingBottom: '20px', paddingTop: '20px' }}>
                        <div className='big-split-768' style={{ width: '100%', display: screen.width >= 768 ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ width: '33%', paddingTop: 15 }}>
                                <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                                    <h6 className='gray-text' >
                                        &copy; Isotope Ticketing 2020
                                    </h6>
                                </a>
                            </div>
                            <div style={{ width: '34%' }}>
                                <a href="https://www.facebook.com/isotopeticketing/">
                                    <button className={'new-icon'}>
                                        <LogoFacebook />
                                    </button>
                                </a>
                                <a href="https://www.youtube.com/watch?v=hX9KJdHSxew">
                                    <button className={'new-icon'}>
                                        <LogoYoutube />
                                    </button>
                                </a>
                                <a href="https://www.instagram.com/isotopeticketing/">
                                    <button className={'new-icon'}>
                                        <LogoInstagram />
                                    </button>
                                </a>
                            </div>
                            <div style={{ width: '33%', paddingTop: 15 }}>
                                <h6 className='gray-text'>
                                    Powered by Stripe
                                </h6>
                            </div>
                        </div>
                        <div className='small-split-768' style={{ textAlign: 'center' }}>
                            <div style={{ width: '100%' }}>
                                <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                                    <h6 className='gray-text' >
                                        &copy; Isotope Ticketing 2020<br /><br />
                                    </h6>
                                </a>
                            </div>
                            <div style={{ width: '100%' }}>
                                <a href="https://www.facebook.com/isotopeticketing/">
                                    <button className={'new-icon'}>
                                        <LogoFacebook />
                                    </button>
                                </a>
                                <a href="https://www.youtube.com/watch?v=hX9KJdHSxew">
                                    <button className={'new-icon'}>
                                        <LogoYoutube />
                                    </button>
                                </a>
                                <a href="https://www.instagram.com/isotopeticketing/">
                                    <button className={'new-icon'}>
                                        <LogoInstagram />
                                    </button>
                                </a>
                            </div>
                            <div style={{ width: '100%' }}>
                                <h6 className='gray-text'>
                                    <br />Powered by Stripe
                                </h6>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div >
}

export default injectStripe(withCookies(CheckoutPage));


// WEBPACK FOOTER //
// ./src/pages/campaign/SellPage/Checkout.tsx